export default __webpack_public_path__ + "static/media/camera.7ce7c8fe.svg";